<template>
	<div>
		<div class="modal" @click.self="close">
			<div>
				<div>
					<transition name="fade">
						<div class="modalbusyoverlay" v-if="isAppBusyModal">
							<div class="busyloader"><div><div></div><div></div><div></div><div></div></div></div>
						</div>
					</transition>
					<div>
						<a data-href @click.prevent="close">Luk</a>
						<h3 v-text="dialogTitle">
							Send webshop links
						</h3>
					</div>
					<section>
						<div>
							<form ref="form" @submit.prevent>
								<div class="form-groups">
									<div class="form-group">

										<div class="input-group">
											<label>
												Aftale
											</label>

											<select v-model="agreementID" ref="agreementid">
												<option v-if="agreements.length == 0" value="0">Ingen aftaler fundet</option>
												<option v-if="agreements.length > 1" value="0">Vælg aftale</option>
												<option v-for="(agreement, index) in agreements" :key="index" v-bind:value="agreement.id">
													{{ agreement.name }}
												</option>
											</select><span></span>
										</div>

										<div class="input-group" v-if="agreementID != 0">
											<label>
												Vælg modtagere
											</label>
											<div class="buttons-group">
												<button class="small" :class="{ 'outline' : targettype != 1}" ref="targettypegroupbutton" @click.self="setTargetType(1)">Alle grupper</button>
												<button class="small" :class="{ 'outline' : targettype != 2}" ref="targettypegroupbutton" @click.self="setTargetType(2)">Gruppe</button>
											</div>
										</div>

										<div class="input-group" v-if="agreementID != 0 && targettype == 2">
											<label>
												Vælg gruppe
											</label>

											<select v-model="persongroupID" ref="persongroupid">
												<option v-if="persongroups.length == 0" value="0">Ingen grupper fundet</option>
												<option v-if="persongroups.length > 1" value="0">Vælg gruppe</option>
												<option v-for="(persongroup) in persongroups" v-bind:value="persongroup.id" v-bind:key="persongroup.id">
													{{ persongroup.name }}
												</option>
											</select><span></span>

										</div>

										<div class="input-group">
											<label>
												Send til alle
											</label>

											<div>
												<input type="checkbox" id="sendtoallcheckbox" ref="sendtoallcheckbox" /> <label for="sendtoallcheckbox">Send også til modtagere der allerede har modtaget linket.</label>
											</div>
										</div>
									</div>
								</div>

								<div class="feedback information" v-if="sendStarted && agreementID == 0">
									Afsendelse af links sat igang.
								</div>

								<div class="divider"></div>
								<div class="buttons-group">
									<button type="button" @click.prevent="close" class="text">
										Tilbage
									</button>
									<button type="button" :disabled="!canSendLinks" @click.prevent="sendLinks">
										Send webshop links
									</button>
								</div>
							</form>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { types } from "@/app/types/types";
	import { appFeedbackStateEnum } from "@/app/enums/common";
	import { personTypeEnum } from "@/app/enums/common";

	export default {
		name: "OrderSendWebshopLinks",
		data()
		{
			return {
				dialogTitle: "Send webshop links",
				sendStarted: false,
				customerID: null,
				agreementID: null,
				persongroupID: null,
				customer: null,
				agreements: [],
				targettype: 1,
				personID: 0,
				persons: [],
				personsearchinput: "",
				persongroups: []
			}
		},
		async mounted()
		{
			this.setModalIsVisible()
			this.agreementID = this.$route.params.agreementid
			this.customerID = this.$route.params.customerid
			this.persongroupID = this.$route.params.persongroupid
			this.setAppAsBusyModal();

			try
			{
				var result = await this.$store.dispatch(types.ACTION_GET_CUSTOMER, this.customerID);

				if (result.status == 200)
				{
					this.customer = result.data
					this.dialogTitle = "Send webshop links for " + this.customer.name

					// Get agreements
					let searchdata = { customerID: this.customerID, status: 0, period: 0 }
					var agreementsResult = await this.$store.dispatch(types.ACTION_GET_AGREEMENTS, searchdata);

					if (agreementsResult.status == 200)
					{
						this.agreements = agreementsResult.data

						if (this.agreements.length == 1 && !this.agreementID)
						{
							this.agreementID = this.agreements[0].id
						}

						if (this.persongroupID)
						{
							this.setTargetType(2)
						}

						this.setAppAsIdle()
					}
					else
					{
						this.setAppAsIdle()
						logError("OrderSendWebshopLinks.mounted()", error)
						alert("Der opstod en fejl ved indlæsning af valgt institution. Opdater siden og prøv igen.");
						this.$router.push({ name: "Orders" })
					}
				}
			}
			catch (error)
			{
				this.setAppAsIdle()
				logError("OrderSendWebshopLinks.mounted()", error)
				this.showErrorAlert("Der opstod en fejl ved indlæsning af valgt institution. Opdater siden og prøv igen.");
				this.$router.push({ name: "Orders" })
			}
		},
		destroyed()
		{
			this.setModalNotVisible()
		},
		computed:
		{
			canSendLinks()
			{
				return (this.agreementID != 0 &&
					(
						this.targettype == 1 ||
						this.targettype == 2
					))
			}
		},
		methods:
		{
			async sendLinks()
			{
				if (this.canSendLinks)
				{
					this.setAppAsBusyModal();
					var result = await this.$store.dispatch(types.ACTION_SEND_WEBSHOPLINKS_TO_CLIENTS, {
						customerid: this.customerID,
						agreementid: this.agreementID,
						sendtoall: this.$refs.sendtoallcheckbox.checked,
						persongroupid: this.persongroupID
					});

					if (result && result.status == 200)
					{
						this.setAppAsIdle()
						this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)

						this.agreementID = 0
						this.persongroupID = 0
						this.personID = 0
						this.sendStarted = true
					}
					else
					{
						alert("Der opstod en fejl ved udsendelse af links. Opdater siden og prøv igen.");
						this.setAppAsIdle()
					}
				}
			},
			async setTargetType(target)
			{
				this.setComponentAsBusy()
				this.targettype = target
				this.sendStarted = false

				if (target == 2 && this.persongroups.length == 0)
				{
					let data = { customerid: this.customerID, agreementid: this.agreementID }
					var response = await this.$store.dispatch(types.ACTION_GET_PERSONGROUPS, data);

					if (response.status == 200)
					{
						this.persongroups = response.data;
						this.setComponentAsIdle()
					}
					else
					{
						this.setAppAsIdle()
						logError("OrderSendWebshopLinks.setTargetType()", response.error)
						alert("Der opstod en fejl. Opdater siden og prøv igen.");
					}
				}
			},
			close()
			{
				if (this.persongroupID)
				{
					this.$router.push({ name: "OrdersPersonGroupShow", params: { agreementid: this.agreementID, customerid: this.customerID, persongroupid: this.persongroupID } })
				}
				else
				{
					this.$router.push({ name: "OrdersPersonGroups", params: { agreementid: this.agreementID, customerid: this.customerID } })
				}
			}
		}
	}
</script>